import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../utils/colors';

interface StyledBoxProps {
  density: 'panel' | 'page';
}

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'density',
})<StyledBoxProps>(({ density }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: density === 'panel' ? 6 : 10,

  '& .complianceRow': {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },

  '& .complianceRowLabel': {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: spaceCadet[400],
    '& svg': {
      fontSize: 13,
      display: 'block',
    },
  },

  '& .complianceInstructions': {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    paddingTop: density === 'panel' ? 9 : 12,
    borderTop: `1px solid ${spaceCadet[100]}`,

    '& .complianceInstructionsLabel': {
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      color: spaceCadet[400],
    },

    '& .complianceInstructionsBody': {
      fontSize: density === 'panel' ? 12.5 : 14,
      lineHeight: 1.5,
      color: spaceCadet[500],
      ...(density === 'panel' && {
        '&.clamped': {
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
        },
      }),
    },

    '& .complianceInstructionsSeeAll': {
      alignSelf: 'flex-start',
      fontSize: 12,
      fontWeight: 700,
      color: ultraMarine[500],
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: 0,
    },
  },
}));

export default StyledBox;
